import {
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
  } from "@mui/material";
  import { useRef, useState } from "react";
  import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
  import NocsRequests from "../../stores/NocsRequestsStore";
  import General from "../../stores/GeneralStore";
import CloseIcon from "../../assets/CloseIcon.svg";
import { validateDate } from "@mui/x-date-pickers/internals";
import { observer } from "mobx-react";

  interface Obj {
    [key: string]: string;
  }
  
  interface Props {
    closeModal:any;
  }
  
  const PendingOrderModal = ({ closeModal}: Props) => {
    const ColorAss = General?.ColorAss;
    const contrast=General?.contrast;
    return (
      <div
        style={{
          width:General?.isLargeScreen? "60%":"100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor:General.contrast.contrastColor
          ? General.contrast.contrastColor: '#fff',
          margin: "auto",
          direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",
        }}
      >
         <div
          style={{
            // height: '20%',
            width: "100%",
            justifyContent: "space-between",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background:  General.contrast.contrastBackground? General.contrast.contrastBackground: General?.ColorAss,
            display: "flex",
            alignItems: "center",
          }}
          //className="DynamicBgColor"
        >
          <h1 style={{ color: contrast?.contrastColor ? contrast?.contrastColor :"#fff", justifySelf: "flex-start",fontSize:General?.isLargeScreen?"":"2rem"}}>
          {General?.codeLabels["cm_pending_order"]?.label !== undefined ? General?.codeLabels["cm_pending_order"]?.label : "Pending Request found"}
          </h1>
          <img src={CloseIcon} alt="" onClick={closeModal} />
        </div>
       <div style={{padding:'1rem'}}>
       <span className="DynamicTextColor" style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
       {General?.codeLabels["cm_pend_ord_exts"]?.label !== undefined
                ? General?.codeLabels["cm_pend_ord_exts"]?.label
                : "Pending Move In request found"}
            </span>
            <br />
          
  
        
  
       
  
        <button
          onClick={closeModal}
          style={{
            backgroundColor: General.contrast.contrastBackground? General.contrast.contrastBackground: General?.ColorAss,
            color: "#fff",
            height: "3.5rem",
            width: "12.5rem",
            fontSize:General?.isLargeScreen? `${1.5 * General.accessibility.fontSize}rem`:`${1*General.accessibility.fontSize}rem`,
            marginTop:'2rem',
            border:"none",
            cursor: "pointer",
          }}
          //className="DynamicButtonColor"
        >
          {General?.codeLabels["cm_close"]?.label !== undefined ? General?.codeLabels["cm_close"]?.label : "Close"}
        </button>
       </div>
      </div>
    );
  };
  
  export default observer (PendingOrderModal);
  